import type { ExtractKeysWithDotNotation } from "@tellescope/ui";
import { useTypedSearchParams } from "../../../hooks/use-typed-search-params";

export interface EmailCompositionPanelQueryParams {
  emailCompositionEnduserId?: string;
  emailCompositionEmailAddress?: string;
  emailCompositionCcIds?: string[];
  emailCompositionSubject?: string;
  forward?: boolean;
  emailId?: string;
}

const VALID_EMAIL_COMPOSITION_PANEL_QUERY_PARAM_KEYS = [
  "emailCompositionEnduserId",
  "emailCompositionEmailAddress",
  "emailCompositionCcIds",
  "emailCompositionSubject",
  "forward",
  "emailId",
] as const satisfies ExtractKeysWithDotNotation<EmailCompositionPanelQueryParams>[];

const EMAIL_COMPOSITION_PANEL_ARRAY_KEYS = [
  "emailCompositionCcIds",
] as const satisfies ExtractKeysWithDotNotation<EmailCompositionPanelQueryParams>[];

export const useEmailCompositionPanelSearchParams = () => {
  return useTypedSearchParams<EmailCompositionPanelQueryParams>(
    VALID_EMAIL_COMPOSITION_PANEL_QUERY_PARAM_KEYS,
    EMAIL_COMPOSITION_PANEL_ARRAY_KEYS
  );
};
